import React from 'react';
import { FilterSection } from '@/components/ui';
import { FORMAT_FILTER_OPTIONS } from '../constants/documentConstants';

export const DocumentsFilterSection = ({
  search,
  setSearch,
  formatFilter,
  setFormatFilter,
  filters,
  setFilters,
  onAddClick,
  isOwner,
  onExport,
  isExporting
}) => (
  <FilterSection
    search={search}
    setSearch={setSearch}
    filters={filters}
    setFilters={setFilters}
    onAddClick={isOwner ? onAddClick : undefined}
    addLabel="Add Document"
    onExport={onExport}
    isExporting={isExporting}
  >
    <select
      className="text-[11px] font-bold uppercase tracking-wider bg-white border border-slate-200 hover:border-slate-800 rounded-md px-2.5 py-1.5 focus:outline-none focus:border-slate-800 text-slate-700 min-w-[140px] transition-all cursor-pointer shadow-sm"
      value={formatFilter}
      onChange={(e) => setFormatFilter(e.target.value)}
    >
      {FORMAT_FILTER_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label.toUpperCase()}
        </option>
      ))}
    </select>
  </FilterSection>
);
